/**
 * Map of month abbreviations in Spanish. Note that they are zero-indexed due to
 * JavaScript's life choices.
 *
 * @private
 * @type {{[key: number]: string}}
 */
const ES_MONTHS = {
  0: 'ene',
  1: 'feb',
  2: 'mar',
  3: 'abr',
  4: 'may',
  5: 'jun',
  6: 'jul',
  7: 'ago',
  8: 'sep',
  9: 'oct',
  10: 'nov',
  11: 'dic',
};

/**
 * Returns a Spanish month string that corresponds with the supplied
 * Date. If an `input` is not passed, it will use the result of `new Date();`.
 *
 * @param  {Date} [date] JavaScript Date object, defaults to current date if
 *                       not passed
 * @return {string}
 */
export function esmonth(date = new Date()) {
  return ES_MONTHS[date.getMonth()];
}
